import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { CartModule } from "./cart/cart.module";
import { NavigationModule } from "./navigation/navigation.module";
import { CommonModule } from "@angular/common";
import { ActivatedRoute } from "@angular/router";


@NgModule({
    declarations: [
    ],
    imports: [
        SharedModule,
        CartModule,
        NavigationModule,
        CommonModule
    ],
    exports: [
        CartModule,
        NavigationModule,
        CommonModule
    ]
})
export class MainPageModule {

    promo: string = '';


    constructor(
        private readonly route: ActivatedRoute
    ) {

    }

}